import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import AreasListContainer from './containers/areas-list/areas-list.container';
/**
 * function AreaModule components
 */
export const AreaModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.AREA_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.AREA_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.AREA_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={AreasListContainer}
      />
    </>
  );
};
